export const disabledStatus = 'DISABLED';
export const notAddStatus = 'NOT_ADD';
